<template>
  <div>
    <!-- 位置名称 动态 -->
    <!-- <bread-crumb></bread-crumb> -->
    <!-- 新 专业问答 -->
    <div>
      <BulletinBoard
        :isProd="isProd"
        :api="api"
        :additionalParam="additionalParam"
      >
      </BulletinBoard>
    </div> 
    <!-- <el-form ref="pgc-search-form" :model="form" label-width="90px" class="pgcQa-search">
      <el-form-item label="药品id">
        <el-input style="width: 240px" v-model="form.drugId" placeholder="请输入药品id进行检索"></el-input>
      </el-form-item>
      <el-form-item label="药品通用名">
        <el-input style="width: 240px" v-model="form.genericName" placeholder="请输入药品通用名进行检索"></el-input>
      </el-form-item>
      <el-form-item label="生产厂家">
        <el-input style="width: 240px" v-model="form.manufacturer" placeholder="请输入生产厂家进行检索"></el-input>
      </el-form-item>
      <el-form-item label="规格">
        <el-input style="width: 240px" v-model="form.specification" placeholder="请输入规格进行检索"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="onSumit">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="pgcQa-iebtns">
      <el-button size="small" type="primary" @click="toImportPage">批量新增问答</el-button>
      <el-button size="small" type="primary" @click="toExportPage">批量导出问答</el-button>
    </div>
    <div class="pgcQa--tabel">
      <div class="base-table">
        <div class="base-table-table">
          <el-table :data="pgcQaList">
            <el-table-column
              prop="drugId"
              label="药品ID"
              width="200">
            </el-table-column>
            <el-table-column
              prop="genericName"
              label="药品通用名"
            >
            </el-table-column>
            <el-table-column
              prop="specification"
              label="药品规格"
              width="260">
            </el-table-column>
            <el-table-column
              prop="manufacturer"
              label="生产厂家"
            >
            </el-table-column>
            <el-table-column
              prop="questionCount"
              label="问答数"
              width="150"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="180">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看问答</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    /> -->
  </div>
</template>

<script>
import breadCrumb from "@/components/wiki/breadCrumb";
import pagination from "@/components/wiki/pagination";

import { pgcSelectList } from "@/api/man";
import { applyReactInVue } from 'vuereact-combined'
import { DoctorQA } from '@jdh/content-pc-components';
import { health_pgc_selectList,health_pcs_cat_options } from '../../../../api/doctorQA';

export default {
  name: "diseaseList",
  data() {
    return {
      tenantCode: localStorage.getItem('saas_partnerId'),
      // isProd: env === 'prod'
      isProd: true,
      api:{
        health_pgc_selectList,
        health_pcs_cat_options
      },
      form: {
        genericName: '',
        manufacturer: '',
        specification: '',
        drugId: ''
      },
      // 列表数据
      pgcQaList:[],
      // 分页
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      additionalParam:{
        inputRouter:window.location.origin+"/pgc/import"+window.location.search,
        outputRouter:window.location.origin+"/pgc/export"+window.location.search,
        deleteRouter:window.location.origin+"/pgc/delete"+window.location.search,
        goUrl:window.location.origin+"/pgc/qaDetail"+window.location.search,
      }
    }
  },
  components: {
    breadCrumb,
    pagination,
    BulletinBoard: applyReactInVue(DoctorQA)
  },
  created() {
    console.log("??",window.location.origin+"/pgc/export"+window.location.search)
    this.getDrugData();
  },
  methods: {
    // 获取数据
    getDrugData(val) {
      if (val) {
        this.paginationDataProduct.currentPage = val;
      }

      pgcSelectList({
        pageSize: this.paginationDataProduct.pageSize,
        pageNum: this.paginationDataProduct.currentPage,
        ...this.form
      }).then(res => {
        console.log("🚀 ~ file: pgcQa.vue:107 ~ getDrugData ~ res:", res)
        this.pgcQaList = res.list;
        // 本地存储，用于详情页展示和查询
        localStorage.setItem('pgcQaList',JSON.stringify(res.list));
        this.paginationDataProduct.total = res.total;
        this.paginationDataProduct.currentPage = res.pageNum;
        this.paginationDataProduct.pageSize = res.pageSize;
      })
    },
    // 搜索
    onSumit() {
      console.log('form', this.form)
      this.paginationDataProduct.currentPage = 1;
      this.getDrugData();
    },
    // 重置
    reset(){
      this.form = {
        genericName: '',
        manufacturer: '',
        specification: ''
      }
      this.paginationDataProduct.currentPage = 1;
      this.getDrugData();
    },
    // 切换页码
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      console.log('paginationChangeProduct', this.paginationDataProduct)
      this.getDrugData()
    },
    // 查看问答
    handleClick(row) {
      console.log("🚀 ~ file: pgcQa.vue:142 ~ handleClick ~ row:", row)
      this.$router.push({
        path: '/pgc/qaDetail',
        query:{
          drugId: row.drugId
        }
      });
    },
    // 跳转 批量新增
    toImportPage() {
      this.$router.push({
        path: '/pgc/import'
      })
    },
    // 跳转 批量导出
    toExportPage() {
      this.$router.push({
        path: '/pgc/export'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.pgcQa-search{
  display: flex;
  padding: 10px 0 ;
  margin-bottom: 10px;
  align-items: center;
  background: #fff;
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
